import { ChainID } from '@ankr.com/chains-list';

import { CHAIN_ID_TO_PATH_MAP } from '../constants';

export const mapChainIdToPath = (chainId: ChainID, ignoredIds?: ChainID[]) => {
  if (ignoredIds?.includes(chainId)) {
    return chainId;
  }

  return CHAIN_ID_TO_PATH_MAP[chainId] || chainId;
};
